// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container-feedback {
  margin-top: -50px;
  display: 'flex';
  justify-content: 'center';
}

.feedbackCommentsScroll::-webkit-scrollbar {
  visibility: hidden;
}

.feedback-container {
  background: white;
  padding: 1rem;
  border-radius: 1rem;
}

.feedback-questions-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.feedback-question {
  opacity: 0;
  transform: translateY(20px);
}

/* Animation Keyframes */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.main-container-feedback {
  margin-top: -50px;
  display: 'flex';
  justify-content: 'center';
}

.feedbackCommentsScroll::-webkit-scrollbar {
  visibility: hidden;
}
.col2 {
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-direction: column;
  height: 100%;
}
.col2 .formHeader {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  gap: 1rem;
}
.col2 .formHeader .switch {
  position: relative;
  display: inline-block;
  width: 130px;
  height: 34px;
}

.col2 .formHeader .switch input {
  opacity: 0;
  width: 0;
  height: 0;
  display: none;
}

.col2 .formHeader .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #2196f3;
  transition: 0.4s;
}

.col2 .formHeader .slider:before {
  position: absolute;
  content: '';
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
}

.col2 .formHeader input:checked + .slider {
  background-color: #2196f3;
}

.col2 .formHeader input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

.col2 .formHeader input:checked + .slider:before {
  transform: translateX(95px);
}

.col2 .formHeader .on {
  display: none;
}

.col2 .formHeader .on,
.off {
  color: white;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  font-size: 14px;
  font-family: Verdana, sans-serif;
}

.col2 .formHeader .switch input:checked + .slider .on {
  display: block;
}

.col2 .formHeader .switch input:checked + .slider .off {
  display: none;
}

/* Rounded sliders */
.col2 .formHeader .slider.round {
  border-radius: 34px;
}

.col2 .formHeader .slider.round:before {
  border-radius: 50%;
}

.col2 .formHeader .switch input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.col2 .formHeader .switch input[type='number'] {
  -moz-appearance: textfield;
}

@media (max-width: 900px) {
  .col2 .formHeader {
    display: flex;
    flex-direction: column;
  }
}
@media (max-width: 768px) {
  .col2 img {
    display: none;
  }
  .col2 .formHeader {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
  }
  /* .col2 .formHeader input:checked+.slider:before {
    -webkit-transform: translateX(105px);
    -ms-transform: translateX(105px);
    transform: translateX(105px);
  } */
}
@media (max-width: 500px) {
  .col2 .formHeader {
    display: flex;
    flex-direction: column;
  }
  /* .col2 .formHeader input:checked+.slider:before {
    -webkit-transform: translateX(185px);
    -ms-transform: translateX(185px);
    transform: translateX(185px);
  } */
}
`, "",{"version":3,"sources":["webpack://./src/styles/pages/feedback.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;EACT,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EAEzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EAEvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,8BAA8B;EAChC;EACA;;;;KAIG;AACL;AACA;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;;;;KAIG;AACL","sourcesContent":[".main-container-feedback {\r\n  margin-top: -50px;\r\n  display: 'flex';\r\n  justify-content: 'center';\r\n}\r\n\r\n.feedbackCommentsScroll::-webkit-scrollbar {\r\n  visibility: hidden;\r\n}\r\n\r\n.feedback-container {\r\n  background: white;\r\n  padding: 1rem;\r\n  border-radius: 1rem;\r\n}\r\n\r\n.feedback-questions-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n}\r\n\r\n.feedback-question {\r\n  opacity: 0;\r\n  transform: translateY(20px);\r\n}\r\n\r\n/* Animation Keyframes */\r\n@keyframes fadeInUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(20px);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.main-container-feedback {\r\n  margin-top: -50px;\r\n  display: 'flex';\r\n  justify-content: 'center';\r\n}\r\n\r\n.feedbackCommentsScroll::-webkit-scrollbar {\r\n  visibility: hidden;\r\n}\r\n.col2 {\r\n  padding: 1rem;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-end;\r\n  flex-direction: column;\r\n  height: 100%;\r\n}\r\n.col2 .formHeader {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: row-reverse;\r\n  gap: 1rem;\r\n}\r\n.col2 .formHeader .switch {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 130px;\r\n  height: 34px;\r\n}\r\n\r\n.col2 .formHeader .switch input {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n  display: none;\r\n}\r\n\r\n.col2 .formHeader .slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: #2196f3;\r\n  -webkit-transition: 0.4s;\r\n  transition: 0.4s;\r\n}\r\n\r\n.col2 .formHeader .slider:before {\r\n  position: absolute;\r\n  content: '';\r\n  height: 26px;\r\n  width: 26px;\r\n  left: 4px;\r\n  bottom: 4px;\r\n  background-color: white;\r\n  -webkit-transition: 0.4s;\r\n  transition: 0.4s;\r\n}\r\n\r\n.col2 .formHeader input:checked + .slider {\r\n  background-color: #2196f3;\r\n}\r\n\r\n.col2 .formHeader input:focus + .slider {\r\n  box-shadow: 0 0 1px #2196f3;\r\n}\r\n\r\n.col2 .formHeader input:checked + .slider:before {\r\n  -webkit-transform: translateX(95px);\r\n  -ms-transform: translateX(95px);\r\n  transform: translateX(95px);\r\n}\r\n\r\n.col2 .formHeader .on {\r\n  display: none;\r\n}\r\n\r\n.col2 .formHeader .on,\r\n.off {\r\n  color: white;\r\n  position: absolute;\r\n  transform: translate(-50%, -50%);\r\n  top: 50%;\r\n  left: 50%;\r\n  font-size: 14px;\r\n  font-family: Verdana, sans-serif;\r\n}\r\n\r\n.col2 .formHeader .switch input:checked + .slider .on {\r\n  display: block;\r\n}\r\n\r\n.col2 .formHeader .switch input:checked + .slider .off {\r\n  display: none;\r\n}\r\n\r\n/* Rounded sliders */\r\n.col2 .formHeader .slider.round {\r\n  border-radius: 34px;\r\n}\r\n\r\n.col2 .formHeader .slider.round:before {\r\n  border-radius: 50%;\r\n}\r\n\r\n.col2 .formHeader .switch input::-webkit-outer-spin-button,\r\ninput::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n.col2 .formHeader .switch input[type='number'] {\r\n  -moz-appearance: textfield;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .col2 .formHeader {\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n}\r\n@media (max-width: 768px) {\r\n  .col2 img {\r\n    display: none;\r\n  }\r\n  .col2 .formHeader {\r\n    display: flex;\r\n    align-items: center;\r\n    width: 100%;\r\n    justify-content: space-between;\r\n  }\r\n  /* .col2 .formHeader input:checked+.slider:before {\r\n    -webkit-transform: translateX(105px);\r\n    -ms-transform: translateX(105px);\r\n    transform: translateX(105px);\r\n  } */\r\n}\r\n@media (max-width: 500px) {\r\n  .col2 .formHeader {\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n  /* .col2 .formHeader input:checked+.slider:before {\r\n    -webkit-transform: translateX(185px);\r\n    -ms-transform: translateX(185px);\r\n    transform: translateX(185px);\r\n  } */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
